import React, {useEffect, useState} from 'react'
import {SERVICE_MENU_ITEMS, SideNavBar} from './SideNavBar'
import * as ReactBootstrap from 'react-bootstrap'
import {useSelector} from 'react-redux'

export const DesktopLayout = ({ children }) => {
  const { user } = useSelector((state) => state.auth)
 const [menu,setMenu] = useState()
const { organization } = useSelector((state) => state.machineConfig)
    const { rights } = useSelector((state) => state.userRights)
const filterMenuItemsByRole = (items) => {
       const hasManagerRights = rights?.filter(
         x=>x.has_manager_rights).length>0;
    let t = items.filter((x) => !x.roles || x.roles.includes(user.role) ||(x.managerAllowed &&
        organization?.manager===user.url)||(x.managerAllowed && hasManagerRights))
    return t.map(m => {
        if (!m.content) {
            return m
        } else {
            const validContents = m.content.filter(
                (x) => !x.roles || x.roles.includes(user.role))
            return {...m, content: validContents}
        }
    })
};


  useEffect(() => {
    if(user.department==="service"){
      let temp =   SERVICE_MENU_ITEMS
      setMenu(filterMenuItemsByRole(temp))
    }
  }, []);
  return (
    <div className="container-fluid vh-100">
      <ReactBootstrap.Row id="outer-container">
        <ReactBootstrap.Col
          style={{
            position: 'fixed',
            top: '40px',
            right: 0,
            left: 0,
            zIndex: 9,
            padding: '0px',
          }}
          md="2"
        >
          <SideNavBar menu={menu} brand="easeOn" />
        </ReactBootstrap.Col>

        <ReactBootstrap.Col className="offset-md-2" md="10">
          {children}
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </div>
  )
}
